export const REDIRECT_URI = process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin + "/auth/callback";

export async function buildAuthUrl() {
  const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:8000"}/api/auth/login`, { credentials: "include" });
  if (!response.ok) throw new Error("login_unavailable");
  return (await response.json()).auth_url;
/*
  const params = new URLSearchParams({
    client_id:     CLIENT_ID,
    response_type: "code",
    redirect_uri:  REDIRECT_URI,
    scope:         "openid profile email User.Read",
    response_mode: "query",
    state:         Math.random().toString(36).slice(2) + Date.now(),
    prompt:        "login",
    max_age:       "0",
    domain_hint:   "prodigy.co.il",
  });
  return `https://login.microsoftonline.com/${TENANT_ID}/oauth2/v2.0/authorize?${params}`; */
}
